import { Container, Row, Col } from 'react-bootstrap';
import { Alert } from '@orbita-ui/core';

export function PasswordExpiredInfoPage() {
  return (
    <Container>
      <Row className="mb-3"></Row>
      <Row>
        <Col>
          <Alert
            variant="info"
            title="Aviso importante"
            subtitle="Su clave expiró. Hemos enviado un correo con el enlace para restablecerla. Por favor, revise su bandeja de entrada."
            fullWidth
          />
        </Col>
      </Row>
    </Container>
  );
}
